import React from 'react';
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { routingData } from "./routing";
import { setEncryptionKey, clearEncryptionKey, getCurrentEncryptionKey } from '../utils/secureStorage';
import TamperDetection from '../utility/TamperDetection';



const RedirectRouter = () => {
  let role = sessionStorage.getItem("role");
  const location = useLocation();

  if (role === '[INVALID_MODIFIED_DATA]') {
    console.warn('🚨 Tampering detected! Showing nice try message...');
    // Optional: Clear the session storage to clean up
    sessionStorage.clear();
    clearEncryptionKey();
    // Return the TamperDetection component
    return <TamperDetection />;
  }

  if (!role) {
    return <Outlet />;
  }

  const roleObject = routingData.find((e) => e.role === role)

  return <Navigate to={roleObject.defaultRoute} state={{ from: location }} replace />;
}

export default RedirectRouter